module.exports = __webpack_public_path__ + "static/media/MaterialSymbolsAddAPhotoOutline.5874cc60.svg";